class TipoGenero {
  constructor(dadosTipoGenero) {
    this.id = dadosTipoGenero.id;
    this.nome = dadosTipoGenero.nome;
    this.sigla = dadosTipoGenero.sigla;
  }
}
export default TipoGenero;
